import { useState } from "react";

/** Rows-per-page shared by the admin tables that paginate client-side. */
export const DEFAULT_PAGE_SIZE = 5;

/**
 * Client-side pagination for an already-fetched, already-filtered row set.
 *
 * The current page is CLAMPED to the valid range at render time
 * (`Math.min(page, totalPages)`) rather than corrected in an effect, so when the
 * filtered set shrinks the view snaps to the LAST valid page — never a blank
 * page and never a jump back to page 1. (Resetting to page 1 on a *filter/search
 * change* is a separate concern the caller owns, since only the caller knows
 * when the meaning of the list changed vs. it merely getting shorter.)
 *
 * Extracted from PaymentsHub so the Owners list shares the exact same behaviour
 * instead of re-deriving it inline.
 */
export function usePaged<T>(rows: T[], pageSize: number = DEFAULT_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
  const current = Math.min(page, totalPages);
  const pageRows = rows.slice((current - 1) * pageSize, current * pageSize);
  return { page: current, setPage, totalPages, pageRows, total: rows.length };
}
